'use client';

import { cva } from 'class-variance-authority';
import type { VariantProps } from 'class-variance-authority';
import type React from 'react';
import {
  Switch as ReactAriaSwitch,
  type SwitchProps as ReactAriaSwitchProps
} from 'react-aria-components';

import { useFusionTheme } from '../hooks';

import styles from './Toggle.module.scss';

export type ToggleProps = Omit<ReactAriaSwitchProps, 'style'> &
  VariantProps<typeof toggleVariants> & {
    rightLabel?: string;
    leftLabel?: string;
  };

const toggleVariants = cva(styles.indicator, {
  variants: {
    size: {
      small: styles.small,
      large: styles.large
    }
  }
});

const Toggle: React.FC<ToggleProps> = ({
  className,
  size = 'small',
  leftLabel,
  rightLabel,
  ...toggleProps
}) => {
  const { addThemeClassName } = useFusionTheme();

  return (
    <ReactAriaSwitch
      {...toggleProps}
      className={addThemeClassName(styles.toggleContainer, className)}
    >
      <span className={styles.leftLabel}>{leftLabel}</span>
      <div className={toggleVariants({ size })} />
      <span className={styles.rightLabel}>{rightLabel}</span>
    </ReactAriaSwitch>
  );
};

export default Toggle;
